import React, { useRef, useState } from "react";
import { convertBytesToMB } from "../../helpers";
import { Button, CreateAlert } from "../../modules";

type ImportInputProps = {
	onImport: (form: FormData ,cb: any) => void
  toggleModal: () => void
};

const ImportInput: React.FC<ImportInputProps> = ({ onImport, toggleModal }) => {
  const inputImportRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleImportFile = async (files: FileList | null) => {
    let inValidFile = false;
    let inValidFormat = false;

    if (files) {
      const formData = new FormData();
      for (let i = 0; i < files?.length; i++) {
        if (convertBytesToMB(files[i]?.size) > 100) {
          inValidFile = true;
          break;
        }

        if (
          files[i]?.type &&
          !["excel", "sheet"].some((type: string) =>
            files[i]?.type.includes(type)
          )
        ) {
          inValidFormat = true;
          break;
        }

        formData.append("file", files[i]);
      }

      if (inValidFile) {
        CreateAlert({
          type: "danger",
          message: "File vượt quá dung lượng cho phép",
        });
        return;
      }

      if (inValidFormat) {
        CreateAlert({
          type: "danger",
          message: "Sai định dạng file Excel",
        });
        return;
      }

      setIsLoading(true);
      onImport(formData , () => {
        setIsLoading(false)
        toggleModal()
      })
    }
  };

  const onClickButton = () => {
    if (isLoading) return
    inputImportRef?.current?.click();
  };

  return (
    <>
      <Button label="Nhập file" buttonType="success" onClick={onClickButton} isLoading={isLoading}/>
      <input
        ref={inputImportRef}
        type="file"
        hidden
        onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
          await handleImportFile(e?.target?.files);
          inputImportRef.current.value = "";
        }}
      />
    </>
  );
};

export default ImportInput;
